export default {
  // async
  SET_TABLE: 'SET_TABLE',
  SET_LEGENDA: 'SET_LEGENDA',
  SET_SITUATION: 'SET_SITUATION',
  // fetches black cells with only fold
  SET_FIRST_PAIR: 'SET_FIRST_PAIR',
  SET_SECOND_PAIR: 'SET_SECOND_PAIR',
  SET_PURPLE: 'SET_PURPLE',

  // sync
  SET_CARD1: 'SET_CARD1',
  SET_CARD2: 'SET_CARD2',
  SET_CARD3: 'SET_CARD3',
  SET_CARD4: 'SET_CARD4',
  SET_SUIT: 'SET_SUIT',
  SET_SUIT_QUALITY: 'SET_SUIT_QUALITY',
  SET_BB: 'SET_BB',
  SET_TS: 'SET_TS',
  SET_STAKE: 'SET_STAKE',
  SET_LOWER_TABLE_BB: 'SET_LOWER_TABLE_BB',
  SET_GGPS: 'SET_GGPS',
};
